var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VersionComparator',{scopedSlots:_vm._u([{key:"default",fn:function({ data_ready }){return [_c('CompareKA',{attrs:{"dataReady":data_ready,"kei":_vm.compare_ex_type_sub === 'kei'}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }